import { motion } from 'framer-motion';
import { LossGraph } from '@/components/LossGraph';

interface MLGraphBlockProps {
  onNext?: () => void;
}

export function MLGraphBlock({ onNext }: MLGraphBlockProps) {
  return (
    <motion.section
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-[#191919] py-8 sm:py-16"
      aria-label="Градиентный Спуск Года - Year Timeline"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <motion.header
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h2 className="text-3xl sm:text-4xl font-bold text-white/90 mb-4">📉 Градиентный Спуск Года</h2>
          <p className="text-[#9B9A97] text-sm sm:text-base">Таймлайн года в виде loss-функции</p>
        </motion.header>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          <LossGraph />
        </motion.div>

        {/* Next/Deploy Button */}
        {onNext && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="flex justify-center mt-12"
          >
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={onNext}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-sm transition-colors focus:outline-none focus:ring-2 focus:ring-green-500 min-h-[44px] text-sm sm:text-base"
              aria-label="Trigger final deployment"
            >
              🚀 Deploy & Execute Wish
            </motion.button>
          </motion.div>
        )}
      </div>
    </motion.section>
  );
}
